import React, {Component, Fragment} from 'react'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Collapse from '@material-ui/core/Collapse'

import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import ItemIcon from '@material-ui/icons/Attachment'
import FolderIcon from '@material-ui/icons/Folder'

import PaperBlock from "./../../ui/PaperBlock"

import withStyles from '@material-ui/core/styles/withStyles'

/**
 * 	<TreeList
 * 		items
 * 		selected
 * 		folderIcon
 * 		hideItems
 * 		disableFolder
 * 		itemIcon
 * 		onClickItem = {item}
 * 	/>
 */

class TreeList extends Component {

	list(items) {

		return items.map((item, n) => {

			if (item.type.toString() !== "0") { // file

				if (!this.props.hideItems) {

					return <ListItem
						key = {n}
						button
						selected = {this.props.selected ? this.props.selected.id === item.id : false}
						onClick = {e => {
							e.stopPropagation()
							if (typeof this.props.onClickItem === "function") {
								this.props.onClickItem(item)
							}
						}}
					>

						<ListItemIcon>
							{this.props.itemIcon ? this.props.itemIcon : <ItemIcon />}
						</ListItemIcon>

						<ListItemText primary = {item.name}/>

					</ListItem>

				} else {

					return null

				}

			} else { // folder

				let disableFolder = this.props.disableFolder ? this.props.disableFolder.id === item.id : false

				return <Fragment key = {n}>

					<ListItem
						button
						disabled = {disableFolder}
						selected = {this.props.selected ? this.props.selected.id === item.id : false}
						onClick = {e => {
							e.stopPropagation()
							if (typeof this.props.onClickItem === "function") {
								this.props.onClickItem(item)
							}
						}}
					>

						<ListItemIcon>
							{this.props.folderIcon ? this.props.folderIcon : <FolderIcon />}
						</ListItemIcon>

						<ListItemText primary = {item.name}/>

						<div>
							{item.items.length ? item.expand ? <ExpandLess /> : <ExpandMore /> : null}
						</div>

					</ListItem>

					{
						item.expand && item.items.length && !disableFolder ?
							<Collapse in={item.expand} timeout="auto" unmountOnExit>
								<List className = {this.props.classes.nested}>
									{this.list(item.items)}
								</List>
							</Collapse>
						: null
					}

				</Fragment>

			}

		})

	}

	render() {

		return <PaperBlock style={{width: "auto"}}>
			<List>
				{this.list(this.props.items)}
			</List>
		</PaperBlock>

	}

}

export default withStyles(theme => ({
	nested: {
  		paddingLeft: theme.spacing.unit * 2,
	},
}))(TreeList)
